
import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import CustomSolutionsDialog from './CustomSolutionsDialog';

const CustomSolutionsCallToAction = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <section className="py-20 bg-[#2C2A3A] text-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-10">
            Let's Turn Your Ideas Into <span className="text-gradient">Real-World Results</span>
          </h2>
          
          <Button 
            size="lg" 
            className="bg-primary text-white hover:bg-primary/90 rounded-lg px-8 py-6 text-lg shadow-lg shadow-primary/20 relative overflow-hidden group"
            onClick={() => setIsDialogOpen(true)}
          >
            <span className="relative z-10 flex items-center">
              Book Your Free Custom Solutions Call
              <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
            </span>
            <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-blue-600 to-indigo-600 opacity-0 group-hover:opacity-100 transition-opacity"></span>
          </Button>
          
          <p className="mt-6 text-xl font-medium text-gray-200">
            Expert insights. Practical strategies. No obligation.
          </p>
        </div>
      </div>

      {/* Custom Solutions Dialog */}
      <CustomSolutionsDialog 
        open={isDialogOpen}
        onOpenChange={setIsDialogOpen}
      />
    </section>
  );
};

export default CustomSolutionsCallToAction;
